// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__yoGMj","tabs":"Tabs_tabs__T2Vm0","navWrapper":"Tabs_navWrapper__bcmC9","nav":"Tabs_nav__kKMso","active":"Tabs_active__DDtXG"};